import gql from 'graphql-tag'

export default gql`
	mutation updatePriceLevels($fields: AppConfigAdditionalInput) {
		cashAssist {
			updateAppConfigAdditional(fields: $fields) {
				priceLevels
			}
		}
	}
`
